import React from 'react';
import { GtmComponent } from '../../../types/go-to-market';
import ArchitectureComponentCard from './ArchitectureComponentCard';
import { LIST_HEADING_STYLES } from './ArchitectureDetailStyles';


const ArchitectureComponentList: React.FC<{
  components: GtmComponent[],
  hoveredComponent: GtmComponent['id'] | null,
  setHoveredComponent: (id: GtmComponent['id'] | null) => void,
  pinnedComponent: GtmComponent['id'] | null,
  setPinnedComponent: (id: GtmComponent['id'] | null) => void,
}> = ({
  components,
  hoveredComponent,
  setHoveredComponent,
  pinnedComponent,
  setPinnedComponent,
}) => {

  return (
    <div className="flex flex-col flex-1 gap-4">
      <h3 className={`${LIST_HEADING_STYLES} mb-0`}>Core Components</h3>
      {components?.length > 0 
        ? (<>
            {components.map((component) => (
              <ArchitectureComponentCard
                key={component.id}
                component={component}
                hoveredComponent={hoveredComponent}
                setHoveredComponent={setHoveredComponent}
                pinnedComponent={pinnedComponent}
                setPinnedComponent={setPinnedComponent}
              />)
            )}
          </>)
        : <div className="italic text-gray-50">No components found for this solution.</div>
      }
    </div>
  );
}

export default ArchitectureComponentList;